import { PropsWithChildren, ReactNode, useEffect, useRef, useState } from 'react';

import LoadingCircle from '~components/Loading';
import useIntersectionObserver from '~hooks/useIntersectionObserver';
import { millionFormattedtoString } from '~utils/formatted/number';

import { getPublicCompanyList, ICompanyListBase } from '../helper';
import * as S from './style';

interface ICompanyList extends ICompanyListBase {
  AVG_SALARY: number;
  ROOKEY_SALARY: number;
}

interface Props {
  onIntersect?: () => void;
  isFetching?: boolean;
}

interface ContentsItemProps {
  href: string;
  companyName: string;
  avgSalary: number;
  rookeySalary: number;
}

export default function CompanyList({
  children,
  isFetching,
  onIntersect,
}: PropsWithChildren<Props>) {
  const ref = useRef<HTMLDivElement>(null);
  const entry = useIntersectionObserver(ref, {
    rootMargin: '0px',
    threshold: 0.3,
  });

  useEffect(() => {
    if (entry?.isIntersecting && onIntersect && !isFetching) {
      onIntersect();
    }
  }, [entry, onIntersect, isFetching]);

  return (
    <S.Wrapper>
      <S.ContentsWrapper>
        <S.Row>
          <S.ColumnHeader>기업명</S.ColumnHeader>
          <S.ColumnHeader>평균연봉</S.ColumnHeader>
          <S.ColumnHeader>신입연봉</S.ColumnHeader>
        </S.Row>
        <S.ContentsList>
          {children}
          {isFetching && <LoadingCircle height={160} />}
          <div ref={ref} />
        </S.ContentsList>
      </S.ContentsWrapper>
    </S.Wrapper>
  );
}

export function ContentsItem({ href, companyName, avgSalary, rookeySalary }: ContentsItemProps) {
  return (
    <S.ContentItem href={href} target='_blank'>
      <S.Row>
        <S.Column>{companyName}</S.Column>
        <S.Column>{millionFormattedtoString(avgSalary)}만원</S.Column>
        <S.Column>{millionFormattedtoString(rookeySalary)}만원</S.Column>
      </S.Row>
    </S.ContentItem>
  );
}
